module.exports = __webpack_public_path__ + "static/media/HEK.ec769032.svg";